export default __webpack_public_path__ + "static/media/moonKnight3.363e038d.jpeg";